import Score from './score/Score';
import Summary from './summary/Summary';
import useStore from 'store';
import { Box } from 'v1/ui';

export default function Review() {
  const messagesLoaded = useStore.useMessagesLoaded();

  // Wait for messages to load
  if (!messagesLoaded) return null;

  return (
    <Box sx={{ mt: 32 }}>
      <Score />
      <Summary />
    </Box>
  );
}
